import { BASE_URL } from "@/constants/config";
import {request} from "@/utils/request";

export const CAMPAIGNS_ENDPOINTS = {
  memberCampaignFiles: (idCampaign, idMember) =>
    `${BASE_URL}api/member_campaign/${idCampaign}/${idMember}/files/`,
  campaigns: `${BASE_URL}api/member_campaign/`,
  update_campaigns: (id) => `${BASE_URL}api/member_campaign/${id}/`,
  files: `${BASE_URL}api/member_campaign/files/`,
  all_files: `${BASE_URL}api/member_campaign/all_files/`,
  download_csv: (id_campaign) => `${BASE_URL}api/member_campaign/download_csv/${id_campaign}/`,
  file_types: `${BASE_URL}api/member_campaign/file_types/`,
  download: `${BASE_URL}api/member_campaign/files/download/`,
  campaign: (id) => `${BASE_URL}api/campaigns/${id}/`,
  campaign_member: (campaign_id, member_id) => `${BASE_URL}api/member_campaign/${campaign_id}/${member_id}`,
  all_campaign_member: (id_campaign) => `${BASE_URL}api/member_campaign/members/${id_campaign}/`,
  kpi: (id) => `${BASE_URL}api/member_campaign/${id}/kpi/`,
  campaign_taux: (id) => `${BASE_URL}api/member_campaign/campaign_taux/${id}/`,
  campaign_taux_all: (id) => `${BASE_URL}api/member_campaign/campaign_taux_all/${id}/`,
  update_campaign_member: (id) => `${BASE_URL}api/member_campaign/campaign_member/${id}/`,
  campaign_members_files: (id) => `${BASE_URL}api/member_campaign/campaign_file/${id}/`,
  campaign_members_export: (id, language) => `${BASE_URL}api/member_campaign/campaign_file/${id}/${language}/`,
};

class Campaigns {
  async fetchCampaigns() {
    const { data } = await request({
      url: CAMPAIGNS_ENDPOINTS.campaigns,
      query: {order_by: 'date_start'}
    });
    return data;
  }

  fetchCampaign(id) {
    return request({
      url: CAMPAIGNS_ENDPOINTS.campaign(id),
    });
  }

  fetchCampaignTaux(id) {
    return request({
      url: CAMPAIGNS_ENDPOINTS.campaign_taux_all(id),
    });
  }

  fetchCampaignMember(campaign_id, member_id) {
    return request({
      url: CAMPAIGNS_ENDPOINTS.campaign_member(campaign_id, member_id),
    });
  }

  async createCampaign(payload){
    return await request({
      url: CAMPAIGNS_ENDPOINTS.campaigns,
      method: "POST",
      body: payload,
    });
  }

  async updateCampaign(id, payload) {
    return await request({
      url: CAMPAIGNS_ENDPOINTS.update_campaigns(id),
      method: 'PUT',
      body: payload
    });
  }

  async deleteCampaign(id){
    return await request({
      url: CAMPAIGNS_ENDPOINTS.campaigns,
      method: "DELETE",
      query: {campaign_id: id},
    });
  }
}

export const CampaignServices = new Campaigns();
